import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { Info } from "@/interfaces/general.interface";
import { LoginResponseType, getInfoProps } from "@/interfaces/interfaces";
import { env } from "@/lib/env";
import { getToken } from "@/utils/helpers";

// Function to get the token from localStorage dynamically

// Auth APIS
export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: env.BACKEND_URL,
  }),
  endpoints: (builder) => ({
    // to get the info if redirected from admin
    getLogin: builder.query<
      getInfoProps,
      Partial<{ token: string; type: string }>
    >({
      query: ({ token, type }) => ({
        url: `auth/${type}`,
        headers: {
          Authorization: `Bearer ${token || getToken()}`,
        },
      }),
      transformResponse: (response: APIResponse<getInfoProps>) =>
        response?.data,
    }),
    // loging in api
    doLogin: builder.mutation<
      LoginResponseType,
      Partial<{ data: object; method: string; loginMethod: string }>
    >({
      query: ({ data, loginMethod }) => ({
        url: `auth/login/${loginMethod}`,
        method: "POST",
        body: data,
      }),
      transformResponse: (response: LoginResponseType) => response,
    }),

    // info api
    getInfo: builder.query<Info, unknown>({
      query: () => ({
        url: "auth/info",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
      transformResponse: (response: APIResponse<Info>) => {
        return response?.data;

        // return res?.permissions as TUserPermission[];
      },
    }),

    logout: builder.query<unknown, string>({
      query: () => ({
        url: `auth/logout`,
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
    }),
  }),
});

export const {
  useDoLoginMutation,
  useGetLoginQuery,
  useGetInfoQuery,
  useLazyLogoutQuery,
} = authApi;

// User APIS
